var $0a79c0aba9e5ecc6$exports = {};
$0a79c0aba9e5ecc6$exports = {
  "ascending": "crescente",
  "ascendingSort": function ascendingSort(args) {
    return "classificado pela coluna ".concat(args.columnName, " em ordem crescente");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " pixels");
  },
  "descending": "decrescente",
  "descendingSort": function descendingSort(args) {
    return "classificado pela coluna ".concat(args.columnName, " em ordem decrescente");
  },
  "resizerDescription": "Pressione Enter para come\xE7ar a redimensionar",
  "select": "Selecionar",
  "selectAll": "Selecionar tudo",
  "sortable": "coluna classific\xE1vel"
};
export { $0a79c0aba9e5ecc6$exports as default };